module.exports = __webpack_public_path__ + "img/female.8596abad.png";